import type { ContactImportRow } from "@/lib/contactsDirectoryClient";
import type { ImportMatch, MatchResolution } from "./adminContactsDirectoryShared";

export function withUpdatedImportMatchResolution(
  prev: ImportMatch[],
  key: string,
  resolution: MatchResolution
): ImportMatch[] {
  return prev.map((m) => (m.key === key ? { ...m, resolution } : m));
}

export function withCopiedIncomingFieldToMergedDraft(
  prev: ImportMatch[],
  key: string,
  field: keyof ContactImportRow
): ImportMatch[] {
  return prev.map((m) =>
    m.key !== key
      ? m
      : {
          ...m,
          resolution: "merge",
          mergedDraft: { ...m.mergedDraft, [field]: m.incoming[field] },
        }
  );
}

export function withCopiedAllNonEmptyIncomingFieldsToMergedDraft(
  prev: ImportMatch[],
  key: string
): ImportMatch[] {
  return prev.map((m) => {
    if (m.key !== key) return m;
    const incoming = m.incoming;
    const nextDraft: ContactImportRow = { ...m.mergedDraft };
    const fields: Array<keyof ContactImportRow> = [
      "name",
      "email",
      "phone",
      "company",
      "title",
      "department",
      "contact_path",
      "visibility_level",
      "max_downstream_visibility_level",
      "location_name",
      "location_id",
      "scope",
      "topics",
      "is_active",
      "affiliation",
      "hierarchy_participation",
    ];
    for (const field of fields) {
      const value = incoming[field];
      if (value === null || value === undefined) continue;
      if (typeof value === "string" && !value.trim()) continue;
      if (Array.isArray(value) && value.length === 0) continue;
      (nextDraft as Record<string, unknown>)[field] = value;
    }
    return { ...m, resolution: "merge", mergedDraft: nextDraft };
  });
}
